import { Injectable, signal, computed } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import Swal from 'sweetalert2';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class Api {
   constructor(private http: HttpClient) {}
     private showheader$ = new BehaviorSubject<boolean>(true);
public roleListTeacher = ['Teacher', 'Texp', 'Assmt', 'diraca'];
public roleListAdmin = ['SysAdmin', 'Administrador', 'RH'];
public roleJustAdmin = ['Administrador'];
public roleListVentasAdmin = ['Ventas', 'Administrador'];
public roleAdminsAndDirAc = ['SysAdmin', 'diraca', 'RH'];
public roleSoloSysadmin = ['SysAdmin'];
public roleListExceptTeacher = ['SysAdmin', 'Texp', 'diraca', 'Assmt'];
public roleListAssessments = ['Texp', 'diraca', 'Assmt'];
   Hoy = moment().format('DD-MMM-YYYY HH:mm:ss');
public PagosLenght$ = signal<number>(0);

  private _Pagosvalue$ = new BehaviorSubject<number>(0);
  private _celebracion$ = new BehaviorSubject<string>('');

  readonly Pagosvalue$ = this._Pagosvalue$.asObservable();
    readonly celebracion$ = this._celebracion$.asObservable();
 private _notificaciones = new BehaviorSubject<any[]>([]);
  notificaciones$ = this._notificaciones.asObservable();
  // Method to fetch user data
  apiurl: string = 'https://myscapa.com/scapapi';
    domainurl: string = 'https://myscapa.com/';

    // OPENAI

// 🔹 AI CONTEXT
private _aiContext = new BehaviorSubject<any>(null);
aiContext$ = this._aiContext.asObservable();

// 🔹 CHAT HISTORY
private _aiMessages = new BehaviorSubject<any[]>([]);
aiMessages$ = this._aiMessages.asObservable();
    //End openai

  setNotificaciones(list: any[]) {
    this._notificaciones.next(list);
  }

  NotificationremoveById(id: number) {
    const updated = this._notificaciones.getValue().filter(n => n.id !== id);
    this._notificaciones.next(updated);
  }
  setPagosValue(v: number) {
    this._Pagosvalue$.next(v);

  }
setCelebracion(v: string) {
    this._celebracion$.next(v);

  }
  setShowHeader(value: boolean) {
    this.showheader$.next(value);
  }

  getShowHeader() {
    return this.showheader$.asObservable();
  }
   loadSucursales(filtro?:string): Observable<any[]>  {
    let filtroset;
  //     SELECT *
  // FROM sucursales
  // WHERE FIND_IN_SET(id, (SELECT sucursal FROM sysusers WHERE id = 5));
    if(!filtro){
      filtroset = "status = 'Activo'";
    }else{
        filtroset = filtro;
    }
    return this.http.post<any[]>(`${this.apiurl}/info`, {
      table: 'sucursales',
      filter: filtroset
    });
  }
 getAccessLogs(start?: string, end?: string): Observable<any[]>  {
    let params: any = {};
  if (start) params.start_date = start;
  if (end) params.end_date = end;

  return this.http.post<any>(`${this.apiurl}/logs`, { params });

  }
   getForTable(table:string, filtro:(string | boolean)  = false): Observable<any[]>  {
      if(!filtro){
        filtro = "1=1";
      }
    return this.http.post<any[]>(`${this.apiurl}/info`, {
      table: table,
      filter: filtro
    });
  }
getProcedure(procedure: string, params: any[] = []): Observable<any> {
  return this.http.post<any>(`${this.apiurl}/callit`, {
    function: procedure,
    params: params
  });
}
callitSummary(procedure: string, params: any[] = []): Observable<any> {
  return this.http.post<any>(`${this.apiurl}/callitSummary`, {
    function: procedure,
    params: params
  });
}
   viewAttendance(grupo:any, incio:any, fin:any, single:boolean = false): Observable<any[]>  {
console.log('view att ', single);
    return this.http.post<any[]>(`${this.apiurl}/view_attendance`, {
      single: single,
      gpo: grupo,
      start: incio,
      end:fin,
    });
  }
     SummaryAttendance(grupo:any, incio:any, fin:any): Observable<any[]>  {
    return this.http.post<any[]>(`${this.apiurl}/attendance_summary`, {
      gpo: grupo,
      start: incio,
      end:fin,
    });
  }
  loadAvatar(selectedAvatarFile: any): Promise<string> {
    return new Promise((resolve, reject) => {
      if (!selectedAvatarFile) return resolve('');

      const formData = new FormData();
      formData.append('avatar', selectedAvatarFile);
      console.log(' en API Uploading avatar:', selectedAvatarFile);

      this.http.post<any>('https://myscapa.com/scapapi/avatar', formData).subscribe({
        next: (res) => {
          if (res && res.filePath) {
            resolve(res.filePath);
          } else {
            reject('File path not returned in response');
          }
        },
        error: (err) => reject(err)
      });
    });
  }
  //Adding new user
addUser(userPayload: any): Observable<any> {
       let currentU = `by user: ${localStorage.getItem('userid')}, ${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`

  return this.http.post<any>(`${this.apiurl}/alta`, {
    table: 'sysusers',
    fields: {
      email: userPayload.email,
      usuario: userPayload.usuario,
      mypass: userPayload.mypass, // plain password, backend will hash
      role: userPayload.role,
      status: userPayload.status,
      nombre: userPayload.nombre,
      apellidop: userPayload.apellidop,
      apellidom: userPayload.apellidom,
      sucursal: userPayload.sucursal,
      sucursal_base: userPayload.sucursal_base,
      comenarios: userPayload.comenarios,
      avatar: userPayload.avatar,
      alta:userPayload.alta,
      matricula:userPayload.matricula,
      cumple:userPayload.cumple,
      tel:userPayload.tel,
       sensible:userPayload.sensible ? 1 : 0,
      log: `<p>User created at ${this.Hoy}, ${currentU}</p>`
    }
  });
}

SyncTeacher(): Observable<any> {

  return this.http.post<any>(`${this.apiurl}/sycteacher`, null);
}
  //Adding new user
addStudent(userPayload: any): Observable<any> {
     let currentU = `by user: ${localStorage.getItem('userid')}, ${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`

  return this.http.post<any>(`${this.apiurl}/altagenerica`, {
    table: 'alumnos',
    fields: {
      alta:userPayload.alta,
      email: userPayload.email,
      status: userPayload.status,
      nombre: userPayload.nombre,
      apellidop: userPayload.apellidop,
      apellidom: userPayload.apellidom,
      sucursal: userPayload.sucursal,
      comentarios: userPayload.comentarios,
      avatar: userPayload.avatar,
      modalidad: userPayload.modalidad,
      kids: userPayload.kids,
      material: userPayload.material,
      cuota: userPayload.cuota,
      cuota_extra: userPayload.cuota_extra,
      descuento:userPayload.descuento,
      diaspago: userPayload.diaspago,
      nivel: userPayload.nivel,
      grupo: userPayload.grupo,
      evaluaciones: userPayload.evaluaciones,
      telefono: userPayload.telefono,
      matricula: userPayload.matricula,
      freshman: 1,
      frashmanFollow:userPayload.frashmanFollow,
      extraclase: userPayload.extraclase,
      factura: userPayload.factura,
      nacimiento: userPayload.nacimiento,
      doneby: userPayload.Doneby,
      reinscripcion: userPayload.reinscripcion ? 1 : 0,
      reindate: userPayload.reinscripcion ? moment().format('YYYY-MM-DD') : null,
      fromdemoID:userPayload.fromdemoID || null,
      extragpo: userPayload.extraclase == 1 ? userPayload.extragpo : 0,
      log: `<p>User created at ${this.Hoy}${currentU}</p>`
    }
  });
  // Escondidos
  //  Hrde: userPayload.Hrde,
  //     Hra: userPayload.Hra,
        // dias: userPayload.dias,
      // teacher: userPayload.teacher,
}
updateStudent(userPayload: any): Observable<any> {
     let currentU = `by user: ${localStorage.getItem('userid')}, ${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`

  return this.http.post<any>(`${this.apiurl}/updategenerica`, {
    tabla: 'alumnos',
    id: userPayload.id,
      alta:userPayload.alta,
      email: userPayload.email,
      status: userPayload.status,
      baja: userPayload.baja,
      nombre: userPayload.nombre,
      apellidop: userPayload.apellidop,
      apellidom: userPayload.apellidom,
      sucursal: userPayload.sucursal,
      comentarios: userPayload.comentarios,
      avatar: userPayload.avatar,
      modalidad: userPayload.modalidad,
      kids: userPayload.kids,
      material: userPayload.material,
      cuota: userPayload.cuota,
      cuota_extra: userPayload.cuota_extra,
      descuento:userPayload.descuento,
      diaspago: userPayload.diaspago,
      nivel: userPayload.nivel,
      grupo: userPayload.grupo,
      evaluaciones: userPayload.evaluaciones,
      telefono: userPayload.telefono,
      matricula: userPayload.matricula,
      extraclase: userPayload.extraclase,
      factura: userPayload.factura,
      nacimiento: userPayload.nacimiento,
      doneby: userPayload.Doneby,
      frashmanFollow:userPayload.frashmanFollow,
      reinscripcion: userPayload.reinscripcion ? 1 : 0,
      reindate: userPayload.reinscripcion ? moment().format('YYYY-MM-DD') : null,
      extragpo: userPayload.extraclase == 1 ? userPayload.extragpo : 0,
      log: `<p>User pdated at ${this.Hoy}, ${currentU}</p>`

  });
  // Escondidos
  //  Hrde: userPayload.Hrde,
  //     Hra: userPayload.Hra,
        // dias: userPayload.dias,
      // teacher: userPayload.teacher,
}
addDemos(userPayload: any, table:string, demo:boolean = false): Observable<any> {
 return this.http.post<any>(`${this.apiurl}/altademoNew`, {
    table: table,
    fields: userPayload
  });

}
runVacationDailyProcess(): Observable<any>{
return this.http.post<any>(
  `${this.apiurl}/check_vacations`,
  {}
);
}
addItem(userPayload: any, table:string, demo:boolean = false): Observable<any> {

  if(demo){
    console.log('Adding to demo table altademo');
 return this.http.post<any>(`${this.apiurl}/altademo`, {
    table: table,
    fields: userPayload
  });
  }else{
        console.log('Adding to demo table altagenerica');

  return this.http.post<any>(`${this.apiurl}/altagenerica`, {
    table: table,
    fields: userPayload
  });
   }
}
addAssessment(userPayload: any, table:string): Observable<any> {

  return this.http.post<any>(`${this.apiurl}/assessment`, {
    table: table,
    fields: userPayload
  });

}
Schedules(fields: any): Observable<any> {

   return this.http.post<any>(`${this.apiurl}/schedules`, {
    fields
  });

}
substitute(userPayload: any, table:string): Observable<any> {

    userPayload['table'] = table;

 return this.http.post<any>(`${this.apiurl}/substitute`, {
    fields: userPayload
  });

}

SetTemGps():Observable<any> {
  let eshoy = localStorage.getItem('tem_gpos');
  eshoy = eshoy ? moment(eshoy).format('YYYY-MM-DD') : null;
  if(eshoy != moment().format('YYYY-MM-DD').toString()){
       return this.http.post<any>(`${this.apiurl}/set_temp_on`, null);
  }
              return of({run:false, msg:'already done temp gps'});



}

updateUser(userPayload: any): Observable<any> {
   let currentU = `by user: ${localStorage.getItem('userid')}, ${localStorage.getItem('nombre')} ${localStorage.getItem('apellido')}`
// Base fields
  const fields: any = {
    id: userPayload.id,
    email: userPayload.email,
    usuario: userPayload.usuario,
    role: userPayload.role,
    status: userPayload.status,
    nombre: userPayload.nombre,
    apellidop: userPayload.apellidop,
    apellidom: userPayload.apellidom,
    sucursal: userPayload.sucursal,
    sucursal_base: userPayload.sucursal_base,
    comenarios: userPayload.comenarios,
    avatar: userPayload.avatar,
    alta:userPayload.alta,
    matricula:userPayload.matricula,
    cumple:userPayload.cumple,
    tel:userPayload.tel,
    sensible:userPayload.sensible ? 1 : 0,
    log: `<p>User updated at ${this.Hoy}, ${currentU}</p>`
  };
   // Only add password if provided
  if (userPayload.mypass && userPayload.mypass.trim() !== "") {
    fields.mypass = userPayload.mypass; // plain password, backend will hash
  }
  return this.http.post<any>(`${this.apiurl}/update`, {
    table: 'sysusers',
    id: userPayload.id, // Assuming userPayload contains an 'id' field
    fields
  });
}


  // Message system
  showMessageWithAnimation(text: string, type: 'success' | 'error' | 'warning' | 'info', time = 3000): void {
    let messageText = text;
    let messageType = type;
    let showMessage = true;
Swal.fire({
  // title: "loading...",
  text: messageText,
  icon: messageType,
  showConfirmButton: false,
  timer: time,
  timerProgressBar: false,

});
  }
deleData(tabla: string, filtro: any): Observable<any> {
    const payload: any = {
      tabla,
      filter: filtro
    };

    return this.http.post<any>(`${this.apiurl}/del`, payload);
  }
DelDataGEn(tabla: string, id: any): Observable<any> {
    const payload: any = {
      tabla,
      id: id
    };

    return this.http.post<any>(`${this.apiurl}/bajagenerica`, payload);
  }
 rawquery(tabla: string, query: any): Observable<any> {
    const payload: any = {
      tabla,
      id: query,
    };


    return this.http.post<any>(`${this.apiurl}/qinfo`, payload);
  }
  updateData(tabla: string, formValue: any, idField: string = 'id'): Observable<any> {
    const payload: any = {
      tabla,
      id: formValue[idField]
    };

    // Remove 'id' from the payload and add the rest of the fields
    for (const key in formValue) {
      if (key !== idField) {
        payload[key] = formValue[key];
      }
    }

    return this.http.post<any>(`${this.apiurl}/updategenerica`, payload);
  }

attendance(userPayload: any): Observable<any> {

  return this.http.post<any>(`${this.apiurl}/attendance`, {
   tabla: "attendance",
  group: userPayload?.group,
  date: userPayload?.date,
  attend: userPayload?.attend,
  comment: userPayload?.comment,
  chekedby: userPayload?.chekedby,
  student_ids:  userPayload?.student_ids,

  });
  // Escondidos
  //  Hrde: userPayload.Hrde,
  //     Hra: userPayload.Hra,
        // dias: userPayload.dias,
      // teacher: userPayload.teacher,
}

// AI features
setContext(context: { data: any; type: string }) {
  this._aiContext.next(context);

  // reset chat when new dataset is loaded
  this._aiMessages.next([]);
}
setContextFinazas(context: { data: any; type: string }) {

  let optimizedData = context.data;

  if (context.type === 'financial') {
    optimizedData = this.optimizeFinancialData(context.data);
  }

  this._aiContext.next({
    ...context,
    data: optimizedData
  });

  this._aiMessages.next([]);
}
addMessage(role: 'user' | 'bot', text: string) {
  const current = this._aiMessages.getValue();
  this._aiMessages.next([...current, { role, text }]);
}
askAI(question: string, finanzes:boolean=false): Observable<any> {
  const context = this._aiContext.getValue();
  const messages = this._aiMessages.getValue();
  console.log('data ', context);

let payload:any;
  // 🔥 build structured prompt (important)
  let payloadRegular = {
    message: `
You are a data analyst.
Need to answer in spanish unless they ask you to answer in english ok

Context type: ${context?.type}

Data:
${JSON.stringify(context?.data).slice(0, 5000)}

Conversation:
${messages.map(m => `${m.role}: ${m.text}`).join('\n')}

User question:
${question}
`
  };
  let payloadFinanzas = {
 message: `
You are a financial analyst.

STRICT FORMAT RULES:

- If needed and justified, use tables
- when possible use markdown tables (|---|)
- Use bullet points ONLY
- Keep it clean and readable for a dashboard UI
- metino the period review From date to date.
- Where money mentioend rememebr to add fomrat if positive or negative as needed $0,000.00 or -$0,000.00
Structure your response EXACTLY like this:

## Executive Summary
• Students: begening of period ${context.students_start_month} and last day of the report ${context.students_end_month}, witha  differnece of ${context.students_end_month} - ${context.students_start_month}
• max 4 bullets

## Branch Performance
##IF more than one branch otherwhisethe only brnach
## If others branch not present do not mention anyhting about the other branchs to not contaminate the report

Satélite
• Neto:
• Tendencia:
• Problemas:
• Oportunidades:
• Estabilidad:

Escandon
• Neto:
• Tendencia:
• Problemas:
• Oportunidades:
• Estabilidad:

Izcalli
• Neto:
• Tendencia:
• Problemas:
• Oportunidades:
• Estabilidad:

## Forecast (Siguientes 3 Meses)
## if other sucursal not in data do not add it, if possible use table when justified
## if possible in the table add estimated of forcasted new students, dimissed students, average ticket,
## if possible use Sucursal_avg_data data to evaluate average ticket per student and forecast calculation.
• Satélite:
• Escandon:
• Izcalli:

## Actions
• max 5 bullets
Need to answer in spanish unless they ask you to answer in english ok

Data:
${JSON.stringify(context?.data)}

Question:
${question}`
};
payload = payloadRegular
if(finanzes){
  payload = payloadFinanzas
}

  return this.http.post<any>(
    `${this.apiurl}/openai/chat.php`,
    payload
  );
}
private optimizeFinancialDataORG(data: any) {

  const summary: any = {
    date_range: '',
    totals: { income: 0, dismissed_loss: 0, net: 0 },
    by_branch: {},
    daily_trend: [],
    students_start_month:0,
    students_end_month:0,
    metrics: {}
  };

  if (!data?.summary || data?.summary.length === 0) return summary;

  // date range
  const dates = data?.summary.map(d => d.fecha).sort();
  summary.date_range = `${dates[0]} to ${dates[dates.length - 1]}`;

  let totalNet = 0;

  data.summary.forEach(row => {
    const net = Number(row.Total || 0);
    const suc = row.sucursalename || 'unknown';

    totalNet += net;

    // totals
    summary.totals.net += net;

    // branch aggregation
    if (!summary.by_branch[suc]) {
      summary.by_branch[suc] = { net: 0 };
    }
    summary.by_branch[suc].net += net;

    // trend (keep it lighter)
    summary.daily_trend.push({
      date: row.fecha,
      net: net
    });
  });
    summary.students_start_month = data.alumns_start_month;
    summary.students_end_month = data.alumns_until_today;
  // metrics
  summary.metrics.avg_daily_net = Math.round(totalNet / data.length);

  const sorted = [...summary.daily_trend].sort((a, b) => b.net - a.net);

  summary.metrics.best_day = sorted[0];
  summary.metrics.worst_day = sorted[sorted.length - 1];

  // ⚠️ limit trend size (important)
  summary.daily_trend = summary.daily_trend.slice(-30);

  return summary;
}
private optimizeFinancialData(data: any) {

  const summary: any = {
    date_range: '',
    totals: { income: 0, dismissed_loss: 0, net: 0 },
    by_branch: {},
    daily_trend: [],
    students_start_month: 0,
    students_end_month: 0,
    Sucursal_avg_data:{},
    metrics: {}
  };

  if (!data?.summary || data.summary.length === 0) return summary;

  // 📅 Date range
  const dates = data.summary
    .map((d: any) => d.fecha)
    .filter(Boolean)
    .sort();

  summary.date_range = `${dates[0]} to ${dates[dates.length - 1]}`;

  let totalNet = 0;

  // 🔁 Trend map grouped by date
  const trendMap: any = {};

  data.summary.forEach((row: any) => {

    const net = Number(row.Total || 0);
    const suc = row.sucursalename || 'unknown';
    const date = row.fecha;

    totalNet += net;

    // 🔹 totals
    summary.totals.net += net;

    // 🔹 by branch aggregation
    if (!summary.by_branch[suc]) {
      summary.by_branch[suc] = { net: 0 };
    }
    summary.by_branch[suc].net += net;

    // 🔹 group by date
    if (!trendMap[date]) {
      trendMap[date] = {
        date,
        total_net: 0,
        branches: {}
      };
    }

    trendMap[date].total_net += net;

    if (!trendMap[date].branches[suc]) {
      trendMap[date].branches[suc] = 0;
    }

    trendMap[date].branches[suc] += net;
  });

  // 🔹 Convert map → array
  summary.daily_trend = Object.values(trendMap);

  // 🔥 Optional: best / worst branch per day
  summary.daily_trend.forEach((day: any) => {
    const entries = Object.entries(day.branches);

    if (entries.length > 0) {
      const sorted = entries.sort((a: any, b: any) => b[1] - a[1]);

      day.best_branch = sorted[0][0];
      day.worst_branch = sorted[sorted.length - 1][0];
    }
  });

  // 🔹 students info
  summary.students_start_month = data.alumns_start_month || 0;
  summary.students_end_month = data.alumns_until_today || 0;
  summary.Sucursal_avg_data = data.Sucursal_avg || 0;
  // 🔹 metrics
  summary.metrics.avg_daily_net = Math.round(
    totalNet / data.summary.length
  );

  // best/worst day based on total_net
  const sortedDays = [...summary.daily_trend].sort(
    (a: any, b: any) => b.total_net - a.total_net
  );

  summary.metrics.best_day = sortedDays[0] || null;
  summary.metrics.worst_day = sortedDays[sortedDays.length - 1] || null;

  // ⚠️ limit trend size (last 30 days)
  summary.daily_trend = summary.daily_trend.slice(-30);

  return summary;
}
}
